import React, { Fragment } from "react"
import classnames from "classnames"
import styles from "./styles.css"

const PrePaidDocumentsSkeleton = () => {
  const itemTableClasses = classnames(styles.skeleton)
  const itemsClasses = classnames(styles.itemsClasses)
  const itemValueClasses = classnames(styles.skeleton, styles.itemValue)

  const buttonClasses = classnames(styles.button, styles.skeleton)
  return (
    <Fragment>
      <div>
        <table className={styles.table}>
          <thead className={styles.tableHeader}>
            <tr>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
            </tr>
          </thead>

          <tbody className={styles.tableBody}>
            <tr className={itemsClasses}>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>

            <tr className={itemsClasses}>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>

            <tr className={itemsClasses}>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>
          </tbody>
        </table>

        <div className="u-flex u-flexJustifyBetween">
          <div className={buttonClasses}></div>
          <div className={buttonClasses}></div>
        </div>
      </div>
    </Fragment>
  )
}

export default PrePaidDocumentsSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/PrePaidDocumentsSkeleton/index.js